window.localStorage.removeItem("Parse/asew/installationId");
import "./parse.config?v=1.0.0";
import "antd/dist/reset.css?v=1.0.0";
import { ComponentType } from "react";

import { AppFactory, init, StorageAdapterLS } from "@opendash/core";
import { registerIconPack } from "@opendash/icons";

import { LocalUserAdapter } from "./adapter/LocalUserAdapter";
import { LocalNavigationAdapter } from "./adapter/LocalNavigationAdapter";

import { ContactRoute } from "./components/ContactRoute";
import { FrontpageRoute } from "./components/FrontpageRoute";
import { GlossaryRoute } from "./components/GlossaryRoute";
import { VideoRoute } from "./components/VideoRoute";
import { WasserangebotRoute } from "./components/WasserangebotRoute";
import { WasserangebotDetailRoute } from "./components/WasserangebotDetailRoute";
import { WasserherkunftRoute } from "./components/WasserherkunftRoute";
import { WasserverbrauchRoute } from "./components/WasserverbrauchRoute";
import { WasserentwicklungRoute } from "./components/WasserentwicklungRoute";
import { GrundwasserDetailRoute } from "./components/GrundwasserDetailRoute";
import { WasserverbrauchSektorenRoute } from "./components/WasserverbrauchSektorenRoute";
import { PrivathaushaltRoute } from "./components/PrivathaushaltRoute";
import { PrivathaushaltVerbrauchRoute } from "./components/PrivathaushaltVerbrauchRoute";
import { PrivathaushaltPreisRoute } from "./components/PrivathaushaltPreisRoute";
import { PrivathaushaltHaerteRoute } from "./components/PrivathaushaltHaerteRoute";
import { WasseraufbereitungRoute } from "./components/WasseraufbereitungRoute";
import { WasserwerkRoute } from "./components/WasserwerkRoute";
import { TrinkwasserqualitaetRoute } from "./components/TrinkwasserqualitaetRoute";
import { VerteilnetzRoute } from "./components/VerteilnetzRoute";
import { KlimawandelRoute } from "./components/KlimawandelRoute";
import { WasserzaehlerRoute } from "./components/WasserzaehlerRoute";
import { LeitungenRoute } from "./components/LeitungenRoute";
import { WasserkreislaufRoute } from "./components/WasserkreislaufRoute";
import { AbwasserDetailRoute } from "./components/AbwasserDetailRoute";
import { WasserknappheitRoute } from "./components/WasserknappheitRoute";
import { WasserknappheitGrundlagenRoute } from "./components/WasserknappheitGrundlagenRoute";
import { WasserknappheitEntstehungRoute } from "./components/WasserknappheitEntstehungRoute";
import { WasserknappheitFussabdruckRoute } from "./components/WasserknappheitFussabdruckRoute";
import { AdminRoute } from "./components/AdminRoute";
import { FAQRoute } from "./components/FAQRoute";

import { app } from "./state";

import { changeLanguage, onLanguageChange } from "@opendash/i18n";
import { AppProvider } from "./components/AppProvider";
import { LegalRoute } from "./components/LegalRoute";
import { VerwendungshinweisRoute } from "./components/VerwendungshinweisRoute";
import { LocalSourceAdapter } from "./adapter/LocalSourceAdapter";

init("opendash", async (factory: AppFactory) => {
  factory.ui.disableHeader();
  factory.ui.disableFooter();
  // Check
  let a = "Init";
  console.log(a);
  // @ts-ignore
  registerIconPack(await import("@opendash/icons/dist/fa-regular.json"));

  // @ts-ignore
  registerIconPack(await import("@opendash/icons/dist/asew-default.json"));

  // Translations:
  factory.registerLanguage("en", "English");
  factory.registerLanguage("de", "Deutsch", undefined, true);
  factory.registerLanguage("tr", "Türkisch", "en");
  factory.registerLanguage("ru", "Russisch", "en");
  factory.registerLanguage("ro", "Rumänisch", "en");
  factory.registerLanguage("bg", "Bulgarisch", "en");
  factory.registerLanguage("uk", "Ukrainisch", "en");
  factory.registerLanguage("ar", "Arabisch", "en");

  factory.registerTranslationResolver(
    "en",
    "app",

    // @ts-ignore
    async (language) => await import("./translations/en.json")
  );

  factory.registerTranslationResolver(
    "de",
    "app",

    // @ts-ignore
    async (language) => await import("./translations/de.json")
  );

  factory.registerTranslationResolver(
    "tr",
    "app",

    // @ts-ignore
    async (language) => await import("./translations/tr.json")
  );

  factory.registerTranslationResolver(
    "ru",
    "app",

    // @ts-ignore
    async (language) => await import("./translations/ru.json")
  );

  factory.registerTranslationResolver(
    "ro",
    "app",

    // @ts-ignore
    async (language) => await import("./translations/ro.json")
  );

  factory.registerTranslationResolver(
    "bg",
    "app",

    // @ts-ignore
    async (language) => await import("./translations/bg.json")
  );

  factory.registerTranslationResolver(
    "uk",
    "app",

    // @ts-ignore
    async (language) => await import("./translations/uk.json")
  );

  factory.registerTranslationResolver(
    "ar",
    "app",

    // @ts-ignore
    async (language) => await import("./translations/ar.json")
  );

  // Adapter + Plugins
  factory.registerDeviceStorageAdapter(new StorageAdapterLS({ scope: "dev" }));
  factory.registerUserStorageAdapter(new StorageAdapterLS({ scope: "user" }));
  factory.registerUserAdapter(new LocalUserAdapter());
  factory.registerNavigationAdapter(new LocalNavigationAdapter());
  factory.registerSourceAdapter(
    new LocalSourceAdapter({
      sources: [
        {
          id: "ASEW",
          tag: "asew",
          name: "ASEW",
          meta: {},
          parent: null,
        },
        {
          id: "ASEW-categories",
          tag: "ASEW-categories",
          name: "ASEW (Categories)",
          meta: {},
          parent: null,
        },
      ],
    })
  );

  // Frontpage
  const routes = [
    {
      label: "Frontpage",
      path: "/rechnungserklaerer/start",
      icon: "fa:file-pdf",
    } /*
    {
      label: "Glossar",
      path: "/rechnungserklaerer/glossar",
      icon: "fa:book",
    },
    {
      label: "Filme",
      path: "/rechnungserklaerer/filme",
      icon: "fa:video",
    },
    {
      label: "Kontakt",
      path: "/rechnungserklaerer/contact",
      icon: "fa:address-book",
    },
    {
      label: "Individuell",
      path: "/rechnungserklaerer/Individuell",
    },*/,
  ];

  for (const route of routes) {
    factory.registerStaticNavigationItem({
      id: route.path,
      group: "frontpage",
      place: "frontpage",
      label: route.label,
      icon: route.icon ? route.icon : "fa:empty-set",
      order: 10,
      color: "#ffe000",
      link: route.path,
      routeCondition: "**",
      activeCondition: "**",
    });
  }

  factory.registerProviderComponent(AppProvider);

  // Routing

  factory.registerRoute({
    path: "/",
    //redirectPath: "/rechnungserklaerer/rechnung",
    component: makeAsync(FrontpageRoute),
  });
  /*
  factory.registerRoute({
    path: "/rechnungserklaerer/filme",
    component: makeAsync(VideoRoute),
  });

  factory.registerRoute({
    path: "/rechnungserklaerer/filme/:id",
    component: makeAsync(VideoRoute),
  });

  factory.registerRoute({
    path: "/rechnungserklaerer/glossar",
    component: makeAsync(GlossaryRoute),
  });

  factory.registerRoute({
    path: "/rechnungserklaerer/glossar/:id",
    component: makeAsync(GlossaryRoute),
  });*/

  // Wasserklärer Routen
  factory.registerRoute({
    path: "/wasserklaerer/wasserangebot",
    component: makeAsync(WasserangebotRoute),
  });

  factory.registerRoute({
    path: "/wasserklaerer/wasserangebot/angebot",
    component: makeAsync(WasserangebotRoute),
  });

  factory.registerRoute({
    path: "/wasserklaerer/wasserangebot/herkunft",
    component: makeAsync(WasserherkunftRoute),
  });

  factory.registerRoute({
    path: "/wasserklaerer/wasserangebot/verbrauch",
    component: makeAsync(WasserverbrauchRoute),
  });

  factory.registerRoute({
    path: "/wasserklaerer/wasserangebot/entwicklung",
    component: makeAsync(WasserentwicklungRoute),
  });

  factory.registerRoute({
    path: "/wasserklaerer/wasserangebot/detail",
    component: makeAsync(WasserangebotDetailRoute),
  });

  factory.registerRoute({
    path: "/wasserklaerer/wasserangebot/herkunft",
    component: makeAsync(WasserherkunftRoute),
  });

  factory.registerRoute({
    path: "/wasserklaerer/wasserangebot/herkunft/grundwasser",
    component: makeAsync(GrundwasserDetailRoute),
  });

  factory.registerRoute({
    path: "/wasserklaerer/wasserangebot/herkunft/oberflaechenwasser",
    component: makeAsync(GrundwasserDetailRoute), // Verwende erstmal die gleiche Komponente
  });

  factory.registerRoute({
    path: "/wasserklaerer/wasserangebot/herkunft/uferfiltrate",
    component: makeAsync(GrundwasserDetailRoute), // Verwende erstmal die gleiche Komponente
  });

  factory.registerRoute({
    path: "/wasserklaerer/wasserangebot/sektoren",
    component: makeAsync(WasserverbrauchSektorenRoute),
  });

  // Privathaushalt Routen
  factory.registerRoute({
    path: "/wasserklaerer/privathaushalt",
    component: makeAsync(PrivathaushaltRoute),
  });

  factory.registerRoute({
    path: "/wasserklaerer/privathaushalt/verbrauch",
    component: makeAsync(PrivathaushaltVerbrauchRoute),
  });

  factory.registerRoute({
    path: "/wasserklaerer/privathaushalt/preis",
    component: makeAsync(PrivathaushaltPreisRoute),
  });

  factory.registerRoute({
    path: "/wasserklaerer/privathaushalt/haerte",
    component: makeAsync(PrivathaushaltHaerteRoute),
  });

  factory.registerRoute({
    path: "/wasserklaerer/wasseraufbereitung",
    component: makeAsync(WasseraufbereitungRoute),
  });

  factory.registerRoute({
    path: "/wasserklaerer/wasseraufbereitung/wasserwerk",
    component: makeAsync(WasserwerkRoute),
  });

  factory.registerRoute({
    path: "/wasserklaerer/wasseraufbereitung/qualitaet",
    component: makeAsync(TrinkwasserqualitaetRoute),
  });

  factory.registerRoute({
    path: "/wasserklaerer/wasseraufbereitung/verteilnetz",
    component: makeAsync(VerteilnetzRoute),
  });

  // Neue Routen für das Kreislauf-Diagramm
  factory.registerRoute({
    path: "/wasserklaerer/klimawandel",
    component: makeAsync(KlimawandelRoute),
  });

  // Regen- und Grauwassernutzung (3 Tabs)
  factory.registerRoute({
    path: "/wasserklaerer/regenwasser",
    component: makeAsync(KlimawandelRoute),
  });

  factory.registerRoute({
    path: "/wasserklaerer/regenwasser/wasserzaehler",
    component: makeAsync(WasserzaehlerRoute),
  });

  factory.registerRoute({
    path: "/wasserklaerer/regenwasser/leitungen",
    component: makeAsync(LeitungenRoute),
  });

  factory.registerRoute({
    path: "/wasserklaerer/wasserkreislauf",
    component: makeAsync(WasserkreislaufRoute),
  });

  factory.registerRoute({
    path: "/wasserklaerer/abwasser/detail",
    component: makeAsync(AbwasserDetailRoute),
  });

  factory.registerRoute({
    path: "/wasserklaerer/wasserknappheit",
    component: makeAsync(WasserknappheitGrundlagenRoute),
  });

  factory.registerRoute({
    path: "/wasserklaerer/wasserknappheit/grundlagen",
    component: makeAsync(WasserknappheitGrundlagenRoute),
  });

  factory.registerRoute({
    path: "/wasserklaerer/wasserknappheit/entstehung",
    component: makeAsync(WasserknappheitEntstehungRoute),
  });

  factory.registerRoute({
    path: "/wasserklaerer/wasserknappheit/fussabdruck",
    component: makeAsync(WasserknappheitFussabdruckRoute),
  });

  // Admin-Route für Content-Management
  factory.registerRoute({
    path: "/admin",
    component: makeAsync(AdminRoute),
  });

  factory.registerRoute({
    path: "/rechnungserklaerer/contact",
    component: makeAsync(ContactRoute),
  });

  factory.registerRoute({
    path: "/rechnungserklaerer/kontakt",
    component: makeAsync(ContactRoute),
  });

  factory.registerRoute({
    path: "/wasserklaerer/faq",
    component: makeAsync(FAQRoute),
  });

  factory.registerRoute({
    path: "/impressum",
    component: makeAsync(LegalRoute),
    props: {
      scope: "imprintText",
    },
  });

  factory.registerRoute({
    path: "/agb",
    component: makeAsync(LegalRoute),
    props: {
      scope: "tosText",
    },
  });

  factory.registerRoute({
    path: "/datenschutz",
    component: makeAsync(LegalRoute),
    props: {
      scope: "privacyText",
    },
  });

  factory.registerRoute({
    path: "/verwendungshinweis",
    component: makeAsync(VerwendungshinweisRoute),
  });
})
  .then(async () => {
    console.log("init open.DASH");

    const savedLanguage = window.localStorage.getItem(
      "rechnungserklärer/language"
    );

    if (savedLanguage) {
      if (savedLanguage === "ar") {
        document.documentElement.lang = "ar";
        document.documentElement.dir = "rtl";
      } else {
        document.documentElement.lang = "en";
        document.documentElement.dir = "ltr";
      }
      await changeLanguage(savedLanguage);
    }

    onLanguageChange((language) => {
      window.localStorage.setItem("rechnungserklärer/language", language);
    });

    await app.init();
  })
  .catch((error) => {
    console.error("opendash.init error", error);
  });

function makeAsync(comp: ComponentType) {
  return async () => ({ default: comp });
}
